import axios from "axios";

const client = axios.create({
  baseURL: "https://api.templetourism.co.in",
  // baseURL: "http://localhost:8000",
});

export default client;